<template>
  <div class="createTask">
    <div class="title">任务创建(已选择{{ taskSelectData.length }}个设备)</div>
    <el-form
      ref="formRef"
      :model="tableParams"
      size="default"
      label-position="left"
    >
      <el-form-item label="任务名称" prop="laneNo">
        <el-input v-model="tableParams.name"></el-input>
      </el-form-item>
      <el-form-item label="任务类型" prop="laneNo">
        <el-radio-group v-model="tableParams.sourceType" prop="cxfs">
          <el-radio :label="3">监控设备</el-radio>
          <el-radio :label="2">离线视频</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="关注时段">
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="分析倍数" prop="laneNo" class="formItem">
        <el-input v-model="tableParams.speed"></el-input>
        <span v-if="getResourcesData"
          >剩余算力/总算力：{{ getResourcesData.availablePower }}/{{
            getResourcesData.totalPower
          }}</span
        >
      </el-form-item>
    </el-form>
    <div class="moreParam" @click="moreBtn">
      更多参数 &nbsp;<i class="iconfont icon-paixu"></i>
    </div>
    <div class="videoList" v-show="moreData">
      <span class="videoListLabel">视频来源</span>
      <div class="videoListContent">
        <div
          class="videoListItem"
          v-for="(item, index) in taskSelectData"
          :key="index"
          v-show="selectData.length > 0"
        >
          <div>
            <i class="iconfont icon-shipin"></i>
            <span>{{ item.cameraName }}</span>
          </div>
          <i class="iconfont icon-shanchu" @click="delSelectData(item)"></i>
        </div>
      </div>
    </div>
    <div class="footer">
      <h-button type="primary" @click="submit()">确定</h-button>
      <h-button @click="close">取消</h-button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import util from "@util/js";
import _ from "lodash";
import { defineComponent, reactive, toRefs, watchEffect, onMounted } from "vue";
import {
  getResources,
  createClueTask,
} from "@/api/smartApplication/smartApplicationApi.js";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "createTask",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    selectData: {
      type: Object,
      default: [],
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const state = reactive({
      formVisible: false,
      equipmentNum: 8,
      tableParams: {
        name:
          util.getStorage("username") +
          moment(new Date()).format("YYYYMMDDHHmmss"),
        speed: 8,
        sourceType: 3,
        clueTaskType: 0,
        clueTaskLevel: 0,
        sourceList: null,
      },
      moreData: false,
      timeRange: [new Date(), new Date()],
      taskSelectData: [],
      getResourcesData: null,
      startTime: "",
      endTime: "",
    });
    const refData = toRefs(state);
    watchEffect(() => {
      state.taskSelectData = _.cloneDeep(props.selectData);
    });
    watchEffect(() => {
      //设置时间
      state.tableParams.startTime = moment(state.timeRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      state.tableParams.endTime = moment(state.timeRange[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    });
    onMounted(() => {
      const start = new Date();
      state.timeRange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24);
    });
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    const moreBtn = () => {
      state.moreData = !state.moreData;
    };
    const close = () => {
      context.emit("closeCreateTaks");
    };
    //新建任务
    const submit = async () => {
      let select = [];
      state.taskSelectData.forEach((item) => {
        let obj = {
          sourceId: item.otherId,
          sourceName: item.cameraName,
        };
        select.push(obj);
      });
      state.tableParams.sourceList = select;
      state.tableParams.sourceType = 3;
      const res = await createClueTask(state.tableParams);
      if (res && res.falg) {
        ElMessage.success("新增成功");
        context.emit("closeCreateTaks");
      } else {
        ElMessage.error("新增失败");
      }
    };
    //删除摄像头
    const delSelectData = (item) => {
      console.log(state.selectData, item);
      state.taskSelectData = state.taskSelectData.filter((el) => {
        if (item.cameraName !== el.cameraName) {
          return el;
        }
      });
      console.log(state.taskSelectData);
    };
    //获取算力
    const getResourcesAsync = async () => {
      const res = await getResources();
      state.getResourcesData = res.data;
    };
    getResourcesAsync();
    return {
      ...refData,
      moreBtn,
      submit,
      close,
      delSelectData,
    };
  },
});
</script>
<style lang="scss" scoped>
.createTask {
  display: flex;
  flex-direction: column;
  align-items: center;
  --font-color: aliceblue;
  .title {
    margin: 16px 0;
    color: var(--font-color);
  }
  .el-form {
    width: 90%;
    .el-form-item {
      /deep/.el-form-item__label {
        color: var(--font-color);
      }
      /deep/.el-radio__label {
        color: var(--font-color);
      }
    }
    .formItem {
      position: relative;
      span {
        position: absolute;
        right: 16px;
      }
    }
  }
  .moreParam {
    color: aqua;
    cursor: pointer;
    margin-left: 65%;
  }
  .videoList {
    width: 85%;
    height: 180px;
    margin-top: 16px;
    display: inherit;
    .videoListLabel {
      font-size: 14px;
      padding: 0 12px 0 0;
      color: var(--font-color);
    }
    .videoListContent {
      width: 80%;
      height: 100%;
      border: 1px solid #2d3e61;
      overflow: auto;
      .videoListItem {
        @include flex-row-sb-c;
        margin: 14px 8px;
        span {
          margin: 0 20px 0 10px;
          font-size: 14px;
          color: var(--font-color);
        }
        i {
          cursor: pointer;
          color: var(--font-color);
        }
      }
    }
  }
  .footer {
    margin: 16px;
  }
}
</style>
